import { Avatar, Box, Stack, Typography } from "@mui/material";
import React from "react";
import GButtonContained from "./elements/GButtonContained";
import GButtonOutlined from "./elements/GButtonOutlined";
import points from "../assets/icons/points.svg";
import halfCircleMobile from "../assets/icons/halfCircleMobile.svg";
import iconProduct from "../assets/icons/iconProduct.svg";
import { Product } from "../interfaces/products";
import strings from "../helper/strings";
import Cookies from "universal-cookie";
import payKeys from "../config/pay-keys";

interface HeaderMobileProps {
  setOpenPayPage: React.Dispatch<React.SetStateAction<boolean>>;
  setUrlIframe: React.Dispatch<React.SetStateAction<string>>;
  product: Product | undefined;
  executeScroll: () => any;
}

function HeaderMobile(props: HeaderMobileProps) {
  const cookies = new Cookies();

  function sendToPay() {
    props.setUrlIframe(
      `${payKeys}/?product-id=${
        props.product?.productId
      }&catalog-id=${props.product?.catalogId}&manager-id=${cookies.get(
        "refferer"
      )}&gooly=${cookies.get("gooly")}`
    );
    props.setOpenPayPage(true);
  }
  return (
    <Box sx={{ width: 395, alignSelf: "center", display: { lg: "none" } }}>
      <Avatar
        src={halfCircleMobile}
        alt="Remy Sharp"
        sx={{
          left: "43%",
          mb: "-64%",
          mx: "-26%",
          bottom: 90,
          zIndex: 3,
          height: 245,
          width: 245,
        }}
      />
      <Box
        bgcolor="#421763"
        sx={{ borderTopLeftRadius: 500, borderTopRightRadius: 500, mt: 5 }}
      >
        <Stack alignItems="center">
          <Avatar
            src={
              props.product?.template.productIcon
                ? props.product?.template.productIcon
                : iconProduct
            }
            alt="Remy Sharp"
            sx={{
              "& .MuiAvatar-img": {
                width: "auto",
                height: "45%",
              },
              backgroundColor: "#550EC3",
              height: 396,
              pt: 5,
              width: 396,
            }}
          />
          <Box
            sx={{
              alignSelf: "start",
              height: 60,
              width: 60,
              mt: -10,
              mb: 7,
              mx: "10%",
              zIndex: 6,
            }}
            component="img"
            src={points}
          />
          <Box px={5}>
            <Typography
              align="right"
              sx={{
                fontSize: 28,
                fontWeight: 600,
                color: "white",
              }}
            >
              {props.product?.template.header}
            </Typography>
            <Typography
              align="right"
              sx={{ fontSize: 18, color: "white" }}
              pt={2}
            >
              {props.product?.template.subHeader}
            </Typography>

            <Typography
              align="right"
              pt={4.7}
              pb={2}
              sx={{
                fontFamily: "Poppins,Arial",
                color: "white",
                fontWeight: 700,
                fontSize: 30,
              }}
            >
              {props.product
                ? `₪${
                    Number(props.product?.["product.price"]).toLocaleString() ||
                    ""
                  }`
                : ""}
            </Typography>
            <Stack
              direction="row"
              sx={{
                "& > :not(style)": {
                  mx: 0.5,
                  mb: 2,
                },
              }}
            >
              <GButtonOutlined
                width={155}
                color="white"
                text={strings.main.leftMessage}
                handleAction={() => props.executeScroll()}
              />
              <GButtonContained
                handleAction={sendToPay}
                width={155}
                text={strings.main.payOnline}
              />
            </Stack>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
}

export default HeaderMobile;
